import { fetchHandler, HTTP_METHOD, oneLimiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postActivateAccountById = (accountId, payload) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/account/activate`, HTTP_METHOD.POST, payload)

    return oneLimiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}